import { Table } from 'react-bootstrap'
import SiteParamRow from './SiteParamRow'

const SiteParamGroup = ({ group, siteId, api, onSaved }) => {
    return (
        <div className='mb-4'>
            <h5 className='fw-semibold border-bottom pb-2 mb-0'>{group.label}</h5>
            <Table hover className='mb-0' responsive>
                <tbody>
                    {group.params.map(param => (
                        <SiteParamRow
                            key={`${siteId}-${param.paramId}`}
                            dbRow={param}
                            siteId={siteId}
                            api={api}
                            onSaved={onSaved}
                        />
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default SiteParamGroup
